/**
 * Constants for extension IDs used in the application.
 * This object holds unique identifiers for various extensions.
 * 
 * @readonly
 * @enum {string}
 */

export const ExtensionsId = Object.freeze({
    stickers: "stickers",
    reactions: "reactions",
    thumbnailGeneration: "thumbnail-generation",
    linkPreview: "link-preview",
    imageModeration: "image-moderation",
    messageTranslation: "message-translation",
    smartReply: "smart-reply",
    xssFilter: "xss-filter",
    dataMasking: "data-masking",
    polls: "polls",
    whiteboard: "whiteboard",
    document: "document",
    profanityFilter: "profanity-filter"
})